import { render, staticRenderFns } from "./RipaCheckbox.vue?vue&type=template&id=566968e2"
import script from "./RipaCheckbox.vue?vue&type=script&lang=js"
export * from "./RipaCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports